import { createPortal } from 'react-dom';

import { Footer } from '@components/molecules/Footer/Footer';

import {
    MobileModalCloseButton,
    MobileModalContainer,
    MobileModalWrapper,
} from './MobileModal.styled';

export interface MobileModalProps {
    children: React.ReactNode;
    className?: string;
    footer?: boolean;
    onClose: () => void;
    open?: boolean;
    topCloseButton?: number;
    topPadding?: number;
}

const CLOSE_BUTTON_TOP_DEFAULT = 22;
const CLOSE_ICON_SIZE = 24;

/**
 * A basis for building modals for RWD.
 * If you want to add left/right padding use MobileModal.Container as children.
 * Components related to it should be used with dot notation, e.g. MobileModal.Container.
 */
export const MobileModal = ({
    children,
    className,
    footer,
    onClose,
    open,
    topCloseButton = CLOSE_BUTTON_TOP_DEFAULT,
    topPadding = 0,
}: MobileModalProps) => {
    if (!open) return null;

    return createPortal(
        <MobileModalWrapper className={className} topPadding={topPadding}>
            <MobileModalCloseButton
                iconProps={{ icon: 'SvgCloseBig24', size: CLOSE_ICON_SIZE }}
                onClick={onClose}
                testId="7q8dLbA"
                top={topCloseButton}
            />
            {children}
            {footer && <Footer />}
        </MobileModalWrapper>,

        document.getElementById('modal')!,
    );
};

MobileModal.Container = MobileModalContainer;
